<template>
  <div class="MyPulish">
    <top-component></top-component>
    <div class="titlePu">
      <div>国图馆三新供货地方版</div>
    </div>
    <div class="container">
      <div class="search_code">
       <span>首字母排序：</span>
        <ul>
           <!-- <li>全部</li> -->
           <li  v-for="(item, i) in zmArr" :key="i" @click="changeWord(item,i)" :class="{'current':i==index}" >{{item}}</li>
        </ul>
      </div>
      <div class="ListDataContainer" v-if="pages.total > 0">
        <div class="ListDiv" v-for="(item, index) in tableData" @click="PubliClick(item)" :key="index">&emsp;{{item.orgName}}</div>
      </div>
    <div class="none_data" v-else>暂无数据！</div>
      <el-pagination v-if="pages.total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="pages.pageNum" :page-size="pages.pageSize" layout="prev, pager, next, jumper"
        :total="pages.total">
      </el-pagination>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import { searchpage,searchpageCity } from '@/api/img'
  import Axios from "@/api/diyaxios";

  import Cookies from 'js-cookie'
  export default {
    name: 'PublisherNational',
    data() {
      return {
        tableData: [],
        zm:'',
        zmArr:['全部','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
        index:0,
        firstWord:'',
        pages: {
          pageNum: 1,
          pageSize: 64,
          total: 200
        }
      }
    },
    mounted() {
      this.ApiData()
    },
    methods: {
      changeWord(item,i){
        this.firstWord = item != '全部' ? item : '';
        if(this.index != i){
          this.pages.pageNum = 1;
           this.ApiData()
        }
        this.index = i;
      },
      // 国图馆三新供货地方版数据
      ApiData(code) {
        let vm = this;
        var obj = {
            firstWord:vm.firstWord,
            pageNum: this.pages.pageNum,
            pageSize: this.pages.pageSize,
            orgType: 9,
        }
        // searchpageCity(obj).then(response => {
        //   this.tableData = response.entities
        //   this.pages.total = response.total
        // })
         Axios.post('/org/action/page', { params: obj },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(res => {
          if(res.data){
            this.tableData = res.data.list;
            this.pages.total = res.data.total
          }
        }).catch(err => {});

      },
      // 分页
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
      },
      handleCurrentChange(val) {
        this.pages.pageNum = val
        this.ApiData()
      },
      // 行点击
      PubliClick(item) {
        if (item.gid !== null) {
        //   this.$router.push({ name: 'LookPublishingPagesType', query:{obj: JSON.stringify({ pubname2: item.name, goodsType: 1 })}});
            const { href } = this.$router.resolve({
                name: 'supplierdetails',
                query: {
                    obj: JSON.stringify({
                        gid: item.gid,
                        goodsType: 1 ,
                        pubname2:item.orgName })
                }
            });
            window.open(href, '_blank');
        } else {
          this.$message({
            message: '数据异常，请稍后再试',
            type: 'error'
          })
        }
      }
    },
    components: {
      BottomComponent,
      TopComponent
    }
  }
</script>

<style scoped lang="scss">
 .search_code{
   >span{
     float: left;
   }
   >ul{
     float: left;
   }
   padding-left: 11px;
   height: 40px;
   line-height: 40px;
   margin-top: 10px;
   li {
      list-style: none;
      float: left;
      cursor: pointer;
      padding: 0 10px;
      &.current{
        color:#ff7f00;
        font-weight: bold;
      }
    }
 }
  .MyPulish {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* 1、title */
  .titlePu {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .titlePu>div {
    width: 1200px;
    height: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    color: rgba(51, 51, 51, 1);
    font-size: 24px;
    text-align: left;
    font-weight: 500;
    font-family: PingFang-SC-Bold;
  }

  /* 2、内容 */
  .container {
    width: 1200px;
    margin: 0px auto;
  }

  .ListDataContainer {
    height: 430px;
    width: 100%;
    font-size: 0px;
  }

  .ListDiv {
    width: calc(16.6% - 60px);
    margin-left: 10px;
    display: inline-block;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 45px;
    line-height: 45px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
    cursor: pointer;
  }

  .ListDiv:hover {
    color: #175199;
    cursor: pointer;
  }
.none_data{
    height:300px;
    text-align: center;
    padding-top:300px;
}
  .el-pagination {
    margin-top: 50px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Publisher-National.vue